import { render, staticRenderFns } from "./AccesosPersonas.vue?vue&type=template&id=088a9a72&scoped=true"
import script from "./AccesosPersonas.vue?vue&type=script&lang=js"
export * from "./AccesosPersonas.vue?vue&type=script&lang=js"
import style0 from "./AccesosPersonas.vue?vue&type=style&index=0&id=088a9a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a9a72",
  null
  
)

export default component.exports